var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sui 40px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo&buttom-svg",
    transform: "translate(-494.000000, -678.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sui-40px",
    transform: "translate(494.000000, 678.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6FBCF0",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "sui-logo",
    transform: "translate(10.000000, 7.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0026593,10.4265867 L16.0021668,10.4276302 C17.0450442,11.7064913 17.668341,13.3262589 17.668341,15.0880241 C17.668341,16.8759572 17.0264126,18.5177188 15.9553826,19.805249 L15.8632096,19.9161018 L15.8387505,19.7752281 C15.8179028,19.655385 15.7935257,19.5344182 15.7651269,19.4124881 C15.2290784,17.109302 13.4827145,15.1343398 10.6084409,13.5352016 C8.66747103,12.4582998 7.55646114,11.1615385 7.26476575,9.68826359 C7.07638137,8.73553939 7.21643849,7.77860101 7.48710562,6.95897244 C7.75768246,6.13960073 8.16020716,5.45309186 8.50216685,5.03978182 L8.50241308,5.03951693 L9.62047342,3.70242803 C9.81655668,3.46794341 10.1835254,3.46794341 10.3796087,3.70242803 L16.0026593,10.4265867 Z M17.7711842,9.09065371 L17.7713484,9.09017209 L10.2770117,0.128334846 C10.1339506,-0.0427782417 9.86604944,-0.042778322 9.72298828,0.128334846 L2.22858597,9.09025236 L2.22879116,9.09073398 L2.20440592,9.12035359 C0.825297941,10.7939823 0,12.9208956 0,15.2362024 C0,20.6284978 4.47705933,25 10,25 C15.5229981,25 20,20.6284978 20,15.2362024 C20,12.9208956 19.1747103,10.7939823 17.7956433,9.12035359 L17.7711842,9.09065371 Z M4.02176697,10.3976895 L4.02207065,10.3972882 L4.69239798,9.59571232 L4.71265472,9.74364986 C4.72870088,9.86092428 4.74816146,9.97876059 4.77124167,10.0970785 C5.20496405,12.3226435 6.75435832,14.1783246 9.34477494,15.6155583 C11.5964904,16.8688935 12.907515,18.3100604 13.2852359,19.8907365 C13.4428248,20.5503951 13.4709774,21.1993778 13.4026889,21.7668061 L13.3985029,21.8019644 L13.3660002,21.8174565 C12.349716,22.3030095 11.2072786,22.575526 9.99975377,22.575526 C5.76467547,22.575526 2.33125677,19.2233721 2.33125677,15.0880241 C2.33125677,13.3125327 2.96418957,11.681126 4.02176697,10.3976895 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.94518b9a109cbf87facafadabc938151.svg";
export { ForwardRef as ReactComponent };